import React, {useState} from "react";
import * as Icon from 'react-bootstrap-icons';

export default function DocumentRow({item, isDownloaded, downloadDocument}) {
    const [lastDownloadDate, setLastDownloadDate] = useState(null);
    if ((isDownloaded && (!item.lastDownload && !lastDownloadDate)) || !isDownloaded) {

        return (<>
            <tr onClick={() => {
                downloadDocument(item.file);
                let currDate = new Date();
                setLastDownloadDate(currDate.toLocaleDateString() + ' ' +  currDate.toLocaleTimeString());
            }}>
                <td style={{color: "blue"}}>
                    {item.file} <Icon.FileArrowDown/>
                </td>
                <td>
                    {item.fileDate}
                </td>
                <td>
                    {lastDownloadDate? lastDownloadDate : item.lastDownload}
                </td>
            </tr>
        </>)
    }

}